var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 535"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    d: "m29.716 28.368-7.746-7.622a12.25 12.25 0 0 0 3.275-8.325A12.524 12.524 0 0 0 12.622 0 12.52 12.52 0 0 0 0 12.421a12.52 12.52 0 0 0 12.622 12.421 12.7 12.7 0 0 0 7.944-2.774l7.776 7.652a.98.98 0 0 0 1.373 0 .946.946 0 0 0 .001-1.352m-17.094-5.437a10.6 10.6 0 0 1-10.68-10.51 10.6 10.6 0 0 1 10.68-10.51 10.6 10.6 0 0 1 10.68 10.51 10.6 10.6 0 0 1-10.68 10.51",
    "data-name": "Path 175"
  }))));
};
export default SvgSearch;